// extracted by mini-css-extract-plugin
module.exports = {"createButton":"SavePluginSetting_createButton__1rebK"};